import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SearchUI from '../../../widgets/input/SearchUI'
import SelectUI from '../../../widgets/input/SelectUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import './ComplianceReportPage.css'
import RetailRepaymentNavUI from './RetailRepaymentNavUI'

const ComplianceReportPageUI = ({
  context, errorList, complianceReportList, yearMonth, lastCronRunTime,
  onRefreshClick, onPreviousClick, onNextClick, onDownloadComplianceReport,
  selectedFilter, onFilterChange, filterOptionList,
  selectedStatus, onStatusChange, statusList,
  selectedNoticeSent, onNoticeSentChange, noticeSentList,
  onSearchFilterChange, searchFilter, onDsraDipClick, showDsraDip
}) =>
  <SuperUserHomePageUI
    context={context} className='pg_su_cr'
    topnav='compliance' page='compliance'
    centered={!complianceReportList || !errorList}
    dimension='w1600'
  >
    {
      (!complianceReportList || !errorList) &&
      <SpinnerComponentUI />
    }

    {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

    {
      complianceReportList &&
      <div>
        <LRTableActionsUI
          location='top'
          left={
            <div>
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <IconButtonUI icon='icon-download' onClick={onDownloadComplianceReport} label='Download Report' />
                <span className='g_m_left_100 g_large'><b>Compliance Report, {yearMonth.monthName} {yearMonth.year}</b></span>
              </span>
              <div className='g_flex_v' style={{ justifyContent: 'flex-end' }}>
                <div className='g_m_left_100 g_flex_h' >
                  <p className='g_error' style={{ marginRight: '20px' }}>Red: Notice Sent</p>
                  <p className='g_info' style={{ marginRight: '20px' }}>Blue: Dsra dip</p>
                  <p className='g_success'>Green: No Compliances</p>
                </div>
                <RetailRepaymentNavUI
                  context={context}
                  page='compliance'
                />
              </div>
            </div>
          }

          right={
            <span className='g_text_left'>
              <div className='g_flex_v'>
                <div className='g_flex_h g_flex_right'>
                  <Link to='#' onClick={onPreviousClick}>Previous</Link>
                  <span className='g_m_left_100' />
                  <Link to='#' onClick={onNextClick}>Next</Link>
                </div>
                <div className='g_flex_h g_m_top_20'>
                  <div className='g_flex_v' >
                    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
                    <span className='g_muted g_small'>Search by account</span>
                  </div>
                  <div className='g_flex_v g_m_left_50' >
                    <SelectUI selectedKey={selectedStatus} optionList={statusList} onChange={onStatusChange} placeholder="Compliance Status" />
                    <span className='g_muted g_small'>Filter by status</span>
                  </div>
                  <div className='g_flex_v g_m_left_50' >
                    <SelectUI selectedKey={selectedNoticeSent} optionList={noticeSentList} onChange={onNoticeSentChange} placeholder="Notice Sent" />
                    <span className='g_muted g_small'>Filter by Notice Sent</span>
                  </div>
                  <div className='g_flex_v g_m_left_50' >
                    <SelectUI selectedKey={selectedFilter} optionList={filterOptionList} onChange={onFilterChange} placeholder='Select Filter'
                    />
                    <span className='g_muted g_small'>Filter by compliance type</span>
                  </div>
                </div>
              </div>
            </span>
          }
        />
        {/* Cron job last run timestamp */}
        <div className='g_m_top_20 g_muted'>
          <span>Last data update (Cron ran at):
            <b>
              {lastCronRunTime}
            </b>
          </span>
        </div>
        <ComplianceTableUI complianceReportList={complianceReportList} showDsraDip={showDsraDip} onDsraDipClick={onDsraDipClick} />
        {
          complianceReportList.length === 0 &&
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No Non-Compliances'
          />
        }
      </div>
    }
  </SuperUserHomePageUI>

const ComplianceTableUI = ({ complianceReportList, showDsraDip, onDsraDipClick }) => {
  // Calculate the total penal charge
  const cleanNumber = (num) => {
    if (typeof num === "string") {
      return parseFloat(num.replace(/,/g, "")) || 0;
    }
    return Number(num) || 0;
  };

  const filteredComplianceReportList = complianceReportList.filter(account => {
    // if (!account.loanList || account.loanList.length === 0) return false;
    const hasRetailLoan = account.loanList && account.loanList.some(loan => loan.loanType.trim().toLowerCase() === 'retail');
    return !hasRetailLoan;
  });

  const totalPenalCharge = filteredComplianceReportList.reduce((total, account) => {
    //Sum penal charges for non-retail clients
    const accountPenal = account.penalChargeList
      ? account.penalChargeList.reduce((acc, loan) => {
        const amount = cleanNumber(loan.defaultInterestF5);
        return acc + amount;
      }, 0)
      : 0;

    return total + accountPenal;
  }, 0);

  const formattedTotalPenalCharge = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(totalPenalCharge);

  return (
    <CardUI className='scard'>
      <span className='g_flex_h g_flex_right'>
        <span className='g_muted g_small g_m_right_50'>
          Show Dsra Dip Accounts
        </span>
        <SwitchUI checked={showDsraDip} onChange={onDsraDipClick} />
      </span>
      {
        !showDsraDip &&
        <table className='table_cr table'>
          <thead className='g_sticky'>
            <tr>
              <th>Account</th>
              <th>Penal Charge</th>
              <th>Number of Notices Sent</th>
              <th>Compliance Remarks</th>
              <th>Monitoring Remarks</th>
              <th>Legal Remarks</th>
              <th>Legal Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              filteredComplianceReportList.filter(account => account.accountName)
                .filter(function (account) {
                  // Skip if any loan has loanType 'retail'
                  var hasRetailLoan = account.loanList && account.loanList.some(function (loan) {
                    return loan.loanType === 'retail';
                  });
                  return !hasRetailLoan;
                }).map((account, i) => {
                  // Determine the class name based on the number of notices sent
                  const hasMultipleNotices = account.complianceNoticeList && account.complianceNoticeList.some(notice => notice.numberOfNoticesSent > 0);
                  let accountClassName = hasMultipleNotices ? 'g_error' : '';

                  // Determine if the account should be color-coded blue based on legalLanguageCode at clause level
                  if (!hasMultipleNotices && account.loanComplianceList) {
                    const hasBlueClause = account.loanComplianceList.some(loan =>
                      loan.complianceCodeList && loan.complianceCodeList.some(code =>
                        code.clauseList && code.clauseList.some(clause =>
                          clause.legalLanguageCode === 'dsra_dip_in_case_of_emi_default' ||
                          clause.legalLanguageCode === 'dsra_dip_in_case_of_levying_of_penal_charges'
                        )
                      )
                    );
                    if (hasBlueClause) {
                      accountClassName = 'g_info';
                    }
                  }
                  // Set the class name to green if it is not already set to red or blue
                  if (!accountClassName && !account.loanComplianceList) {
                    accountClassName = 'g_success';
                  }

                  return (
                    <tr key={i}>
                      <td className="g_text_left g_no_wrap_2">
                        {i + 1}.
                        <span className={`g_m_left_25 ${accountClassName}`}>
                          {account.accountName && (
                            <span>{account.accountName}</span>
                          )}
                        </span>
                      </td>
                      <td className='g_text_left'>
                        {
                          account.penalChargeList && account.penalChargeList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${loan.loanId}/compliance`}>{loan.loanReferenceNumber}</Link>: {loan.defaultInterestF5}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.complianceNoticeList && account.complianceNoticeList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${loan.loanId}/compliance`}>{loan.loanReferenceNumber}</Link>: {loan.numberOfNoticesSent}
                                {loan.numberOfNoticesSent > 0 && (
                                  <>
                                    <br />
                                    (Sent on: {loan.noticeSentDate})
                                  </>
                                )}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.loanComplianceList && account.loanComplianceList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25 g_flex_top'>
                                <span>
                                  <Link to={`/su/loans/${loan.loanId}/compliance`}>
                                    {loan.loanReferenceNumber}
                                  </Link>
                                  <span className='g_m_right_50' />
                                </span>
                                <span>
                                  {
                                    loan.complianceCodeList.map((compliance, k) => (
                                      <div key={k}>
                                        {
                                          compliance.clauseList
                                            .filter(clause => clause.status === "not_complied") // Filter based on status
                                            .map((clause, m) => {
                                              let DPD = null;

                                              // Determine DPD based on legalLanguageCode
                                              if ([
                                              'share_certificate',
                                              'share_transfer_form',
                                              'form_chg_1',
                                              'pledge_sequence_number',
                                              'extension_letter',
                                              'tax_invoices',
                                              'transit_insurance',
                                              'project_ppa_vehicle_insurance',
                                              'net_metering_certificate',
                                              'registration_certificates',
                                              'non_compliance_of_financial_covenants',
                                              'non_compliance_of_reps_and_warranties',
                                              'non_compliance_of_negative_covenants',
                                              'non_compliance_of_information_covenants'
                                              ].includes(clause.legalLanguageCode)) {
                                                DPD = clause.daysPastDue;
                                              } else if ([
                                                'dsra_dip_in_case_of_emi_default',
                                                'dsra_dip_in_case_of_levying_of_penal_charges',
                                                'emi_default'
                                              ].includes(clause.legalLanguageCode)) {
                                                DPD = clause.financialDaysPastDue;
                                              }

                                              return (
                                                <div key={m}>
                                                  <span><b>{clause.clause}:</b></span><br />
                                                  {![
                                                    'non_compliance_of_sch_vii_and_non_compliance_of_escrow_wrt_routing_of_receivables',
                                                  ].includes(compliance.complianceCode) &&
                                                    DPD !== null && (
                                                      <span className='g_muted g_small'><b>DPD: {DPD} days</b></span>
                                                    )}
                                                  <span>{clause.remarks}</span><br />
                                                </div>
                                              );
                                            })
                                        }

                                      </div>
                                    ))
                                  }

                                </span>
                              </span>
                            </span>
                          )
                        }
                      </td>

                      <td className='g_text_left'>
                        {
                          account.monitoringRemarksList && account.monitoringRemarksList.map((remarks, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${remarks.loanId}/monitoring`}>{remarks.remarksDateF}</Link> {remarks.remarks}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.legalRemarksList && account.legalRemarksList.map((remarks, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${remarks.loanId}/legalRemarks`}>{remarks.remarksDateF}</Link> {remarks.remarks}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.legalRemarksList && account.legalRemarksList.map((action, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${action.loanId}/legalRemarks`}>{action.remarksDateF}</Link> {action.action}
                              </span>
                            </span>
                          )
                        }
                      </td>
                    </tr>
                  );
                })
            }
          </tbody>
          <tfoot>
            <tr>
              <td className='g_text_left'><b>Total</b></td>
              <td className='g_text_left'><b>{formattedTotalPenalCharge}</b></td>
              <td colSpan="5"></td>
            </tr>
          </tfoot>
        </table>
      }
      {
        showDsraDip &&
        <table className='table_cr table'>
          <thead className='g_sticky'>
            <tr>
              <th>Account</th>
              <th>DSRA To be Collected</th>
              <th>Penal Charge</th>
              <th>Number of Notices Sent</th>
              <th>Compliance Remarks</th>
              <th>Monitoring Remarks</th>
            </tr>
          </thead>
          <tbody>
            {
              filteredComplianceReportList.filter(account => account.accountName && account.dsraDip !== null)
                .filter(account => {
                  // Exclude retail loan accounts
                  const hasRetailLoan = account.loanList && account.loanList.some(loan => loan.loanType === 'retail');
                  return !hasRetailLoan;
                }).map((account, i) => {
                  // Determine the class name based on the number of notices sent
                  const hasMultipleNotices = account.complianceNoticeList && account.complianceNoticeList.some(notice => notice.numberOfNoticesSent > 0);
                  let accountClassName = hasMultipleNotices ? 'g_error' : '';

                  // Determine if the account should be color-coded blue
                  if (!hasMultipleNotices && account.loanComplianceList) {
                    const hasBlueClause = account.loanComplianceList.some(loan =>
                      loan.complianceCodeList && loan.complianceCodeList.some(code =>
                        code.clauseList && code.clauseList.some(clause =>
                          clause.clause === 'Clause 10.1(a) - In case of DSRA dip due to EMI default' ||
                          clause.clause === 'Clause 3.3(a) - In case of DSRA dip due to levying of penal charges'
                        )
                      )
                    );
                    if (hasBlueClause) {
                      accountClassName = 'g_info';
                    }
                  }
                  // Set the class name to green if it is not already set to red or blue
                  if (!accountClassName && !account.loanComplianceList) {
                    accountClassName = 'g_success';
                  }

                  return (
                    <tr key={i}>
                      <td className="g_text_left g_no_wrap_2">
                        {i + 1}.
                        <span className={`g_m_left_25 ${accountClassName}`}>
                          {account.accountName && (
                            <span>{account.accountName}</span>
                          )}
                        </span>
                      </td>
                      <td className="g_text_left">
                        {account.dsraDip && <span> ₹ {account.dsraDip}</span>}
                      </td>
                      <td className='g_text_left'>
                        {
                          account.penalChargeList && account.penalChargeList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${loan.loanId}/compliance`}>{loan.loanReferenceNumber}</Link>: {loan.defaultInterestF5}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.complianceNoticeList && account.complianceNoticeList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${loan.loanId}/compliance`}>{loan.loanReferenceNumber}</Link>: {loan.numberOfNoticesSent}
                                {loan.numberOfNoticesSent > 0 && (
                                  <>
                                    <br />
                                    (Sent on: {loan.noticeSentDate})
                                  </>
                                )}
                              </span>
                            </span>
                          )
                        }
                      </td>
                      <td className='g_text_left'>
                        {
                          account.loanComplianceList && account.loanComplianceList.map((loan, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25 g_flex_top'>
                                <span>
                                  <Link to={`/su/loans/${loan.loanId}/compliance`}>
                                    {loan.loanReferenceNumber}
                                  </Link>
                                  <span className='g_m_right_50' />
                                </span>
                                <span>
                                  {
                                    loan.complianceCodeList.map((compliance, k) => (
                                      <div key={k}>
                                        {
                                          compliance.clauseList
                                            .filter(clause => clause.status === "not_complied") // Filter based on status
                                            .map((clause, m) => {
                                              let DPD = null;

                                              // Determine DPD based on legalLanguageCode
                                              if ([
                                              'share_certificate',
                                              'share_transfer_form',
                                              'form_chg_1',
                                              'pledge_sequence_number',
                                              'extension_letter',
                                              'tax_invoices',
                                              'transit_insurance',
                                              'project_ppa_vehicle_insurance',
                                              'net_metering_certificate',
                                              'registration_certificates',
                                              'non_compliance_of_financial_covenants',
                                              'non_compliance_of_reps_and_warranties',
                                              'non_compliance_of_negative_covenants',
                                              'non_compliance_of_information_covenants'
                                              ].includes(clause.legalLanguageCode)) {
                                                DPD = clause.daysPastDue;
                                              } else if ([
                                                'dsra_dip_in_case_of_emi_default',
                                                'dsra_dip_in_case_of_levying_of_penal_charges',
                                                'emi_default'
                                              ].includes(clause.legalLanguageCode)) {
                                                DPD = clause.financialDaysPastDue;
                                              }

                                              return (
                                                <div key={m}>
                                                  <span><b>{clause.clause}:</b></span><br />
                                                  {![
                                                    'non_compliance_of_sch_vii_and_non_compliance_of_escrow_wrt_routing_of_receivables',
                                                  ].includes(compliance.complianceCode) &&
                                                    DPD !== null && (
                                                      <span className='g_muted g_small'><b>DPD: {DPD} days</b></span>
                                                    )}
                                                  <span>{clause.remarks}</span><br />
                                                </div>
                                              );
                                            })
                                        }

                                      </div>
                                    ))
                                  }

                                </span>
                              </span>
                            </span>
                          )
                        }
                      </td>

                      <td className='g_text_left'>
                        {
                          account.monitoringRemarksList && account.monitoringRemarksList.map((remarks, j) =>
                            <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                              <span>{j + 1}.</span>
                              <span className='g_m_left_25'>
                                <Link to={`/su/loans/${remarks.loanId}/monitoring`}>{remarks.remarksDateF}</Link> {remarks.remarks}
                              </span>
                            </span>
                          )
                        }
                      </td>
                    </tr>
                  );
                })
            }
          </tbody>
          <tfoot>
            <tr>
              <td className="g_text_left">
                <b>Total</b>
              </td>
              <td className="g_text_left">
                <b>
                  ₹{" "}
                  {new Intl.NumberFormat("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    (complianceReportList || []).reduce((sum, account) => {
                      //Check if the account has NO retail loans
                      const hasRetailLoan = account.loanList && account.loanList.some(loan => loan.loanType === 'retail');
                      if (hasRetailLoan) return sum;

                      const dsraDipStr = account.dsraDip || "0";
                      const dsraDipNum = parseFloat(dsraDipStr.toString().replace(/,/g, "")) || 0;
                      return sum + dsraDipNum;
                    }, 0)
                  )}
                </b>
              </td>
              <td colSpan="5"></td>
            </tr>
          </tfoot>
        </table>
      }
    </CardUI>
  );
};

export default ComplianceReportPageUI
